export interface IMatchIncludeRulesAivo {
  plural: string[];
  singular: string[];
}

export interface IMatchIncludeRulesAivo {
  [key: string]: string[];
}

export interface IRulesMatchAivo {
  include?: IMatchIncludeRulesAivo;
  exclude?: IMatchIncludeRulesAivo;
}

export interface IConfigurationsRulesAivo {
  token: string;
}

export interface IRulesRulesAivo {
  match: IRulesMatchAivo;
}

export interface IRulesAivo {
  id: number;
  state: string;
  name: string;
  configurations: IConfigurationsRulesAivo;
  rules: IRulesRulesAivo;
}

export interface IUserInformation {
  name?: string;
  NIT?: string;
  serial?: string;
  planType?: number;
  prepaidPlanType?: number;
  allowInvoices?: number;
}

export interface IFeedbackCount {
  good: number;
  bad: number;
}

export interface ILastQuestionInformation {
  type: string;
  question: string;
}

export interface IConfigurationsAivo {
  url: string;
  release: string;
}

export enum STATUS {
  OK = "ok",
  OPEN = "open",
  CLOSED = "closed",
}

export enum EVENTS {
  LOAD = "load",
  ERROR = "error",
}

export enum SCRIPT_ELEMENTS {
  SCRIPT = "script",
  ID = "id",
  SRC = "src",
}

export enum EVENTS_BUTTONS {
  MESSAGE_CONTACT_ADVISER = "message_contact_adviser",
  TALK_WITH_ADVISER = "Hablar con un asesor",
}

export const CALL_TO_ACTION_MESSAGES = {
  ADVISER: "Comunicarme con un asesor",
};

export const FEEDBACK = {
  PROPERTY: "feedbackCount",
  BAD: {
    ADVISER: {
      MAXIMUM: 2,
    },
  },
};

export const DELTA = 6;

export const INTERACTION = {
  TYPES: {
    INTENTION: "intention",
    EVASION: "evasion",
    EVASION_GARBAGE: "evasion garabage", // Debería ser "evasion garbage" pero así mal escrito lo devuelve Aivo
  },
  CONSECUTIVE_UNANSWERED_QUESTIONS_TO_SHOW_ADVISER_BUTTON: 2,
};

export const AGENT_APP_CONTAINER_ID: string = "AgentAppContainer";
export const BUTTON_CLOSE_ID: string = "button-close";
export const LAUNCHER_CLASS_ID: string = "aivochat-launcher";
export const STYLES_ID: string = "aivo-styles";
export const ICON_IMAGE: string =
  "https://my.aivo.co/assets/img/cta_icon_FFFFFF.png";
export const SCRIPT_ID: string = "AIVO";
export const BUTTON_EVENT_SEPARATOR: string = "|||";
export const KEY_LOCAL_STORAGE_RULES_AIVO: string = "rulesAivo";
export const EXTERNAL_RESOURCES = {
  RULES: "aivo/rules.json",
  CONFIGURATIONS: "aivo/configurations.json",
};
export const AMOUNT_OF_RETRIES: number = 3;
export const MATCH_INCLUDE_RULES_AIVO: IMatchIncludeRulesAivo = {
  singular: ["serial", "planType"],
  plural: ["serials", "planTypes"],
};
export const INTERVAL_GENERAL: number = 300;